import { configureStore } from '@reduxjs/toolkit';
import utilsSlice from '../utils/utilsSlice';
import usersSlice from '../features/users/slices/usersSlice';
import teamSlice from '../features/users/slices/teamSlice';
import rolSlice from '../features/users/slices/rolSlice';
import authSlice from '../features/authentication/slices/authSlice';
import companiesSlice from '../features/companies/slices/companiesSlice';
import projectsSlice from '../features/projects/slices/projectsSlice';
import sectionsSlice from '../features/projects/slices/sectionsSlice';

const store = configureStore({
  reducer: {
    projects: projectsSlice,
    sections: sectionsSlice,
    auth: authSlice,
    roles: rolSlice,
    teams: teamSlice,
    users: usersSlice,
    utils: utilsSlice,
    companies: companiesSlice
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;